declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (...args: unknown[]) => void;
  }
}

export type MarketingCtaLocation =
  | 'comparison_hero'
  | 'comparison_mid'
  | 'comparison_cta_section'
  | 'comparison_faq';

/**
 * Pushes to dataLayer (GTM), forwards to gtag if present, and dispatches a DOM event for any custom listeners.
 */
export function trackMarketingEvent(
  action: string,
  detail?: Record<string, string | undefined>
): void {
  const payload = { event: 'geofleet_marketing', action, ...detail };
  try {
    window.dataLayer?.push(payload);
  } catch {
    /* ignore */
  }
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', action, detail ?? {});
    }
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent('geofleet:marketing', { detail: payload }));
  } catch {
    /* ignore */
  }
}

export function trackCtaClick(
  label: string,
  location: MarketingCtaLocation,
  extra?: Record<string, string | undefined>
): void {
  trackMarketingEvent('cta_click', {
    cta_label: label,
    cta_location: location,
    ...extra,
  });
}

export function trackDemoBookingClick(
  location: MarketingCtaLocation,
  extra?: Record<string, string | undefined>
): void {
  trackMarketingEvent('demo_booking_click', {
    cta_location: location,
    ...extra,
  });
}
